export default {
  language: 'cn',
  morequerytext1: '更多查询',
  morequerytext12: '查询其他客票',
  morequerytext2: '没有找到要退改的机票（测试环境非人脸）',
  reminder1: '温馨提示',
  reminder2: '温馨提示：',
  writeText1: '请输入正确的证件号',
  writeText2: '请前往小程序或南航App进行更多客票查询',
  writeText_3:
    '您好，为保障行程信息安全，需进行实名认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText3:
    '您好，为保障行程信息安全，需进行人脸识别认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText4:
    '您好，为防范金融风险，更多查询需进行人脸识别，请更新最新版APP进行操作，谢谢',
  photoTip: '请先更新APP最新版本后再使用上传文件功能。',
  inputText: '请输入您的信息',
  labeltext1: '证件号码：',
  labeltext2: '姓：',
  labeltext3: '名：',
  labeltext4: '姓',
  labeltext5: '名',
  writeTip2: '请输入证件号',
  writeTip3: '请输入姓',
  writeTip312: '乘机人的姓',
  writeTip322: '乘机人的名',
  writeTip4: '请输入名字',
  writeTip4qw: '姓名包含特殊字符',
  writeTip466: '查询',
  writeTip5: '由于姓名包含特殊字符，请再次选择并确认您的姓名信息',
  writeTip6: '长度不能超过20个字符',
  wxFaceCheck: '微信实名认证',
  inpTip1: '请填写信息，以完成实名认证',
  inpTip2: '请输入姓/名',
  idNum: '身份证',
  openFaceCheck: '开启人脸识别',
  tip1:
    '温馨提示：若您的姓名包含“·”，请勾选“姓名包含特殊字符”选项，系统将在姓和名之间添加“·”作为您的实际姓名进行认证，否则会认证失败。',
  tip2: '1、航班延误/取消时,允许免费改期的航班范围以实际为准',
  tip3: '2、变更计算结果仅为手续费,实际变更时可能需支付票价差额',
  tip4: '3、以上退改说明仅供参考,请以南航实际规定为准',
  tip5: '以上退改说明仅供参考，请以南航实际规定为准',
  lookAgin: '再看看',
  realName: '实名认证',
  calculateR: '退票计算',
  calculateC: '变更计算',
  refunMen: '退票航段',
  leg: '航段',
  detailsR: '可退金额明细',
  amount: '票面价',
  tax: '可退税费',
  insurPremium: '保险费',
  noinsurPremium: '不可退保险费',
  handlingFee: '退票手续费',
  coupon: '优惠券',
  refundableAmount: '可退金额',
  confirm: '确定',
  applicableLeg: '适用航段',
  rules: '规则',
  CostDisplay: '费用展示',
  dateNow: '按当前时间计算',
  cFee: '变更手续费',
  tipRefun: '客票变更时根据您实际选择的新航班及舱位，可能需补充支付票价差额',
  clickTip: '点击底部 按钮 可获取详细费用',
  receivedR: '已退票',
  receivedU: '已使用',
  receivedC: '已变更',
  unavailable: '不可用',
  seleLeg: '选择变更',
  refundLeg: '退票航段',
  rulesFC: '退改规则',
  rulesdetailed: '详细规则',
  choose: '选择',
  chooseMore: '更多选择',
  name: '姓名',
  ticketNo: '票号',
  taxes: '税费',
  otherTicketses: '其他客票退改计算',
  ticketnoInp: '请输入票号或者证件号',
  ticketNoID: '票号 / 证件号',
  passengerName: '请输入旅客姓名',
  inpTip3: '请输入实际承运航班号（如CZ605）',
  flightNo: '航班号',
  flightDate: '航班日期',
  tip6: '1、暂仅支持南航实际承运国内航班的电子客票(784开头)；',
  tip7: '2、团队、里程兑换、政府采购、礼遇等客票类型暂不支持；',
  tip8:
    '3、如您的客票无法查询退改手续费，可能是我们的服务范围暂未覆盖，敬请谅解！您可联系原出票服务商或南航客服95539咨询！',
  nextStep: '下一步',
  openCard: '开卡证件',
  cardNo: '证件号码',
  cardNoBin: '银行卡Bin',
  checkMessage: '请核对填写公务卡开卡信息',
  titel1: '选座&办登机牌',
  titel2: '接送机',
  titel3: '代客泊车',
  titel4: '贵宾休息室',
  titel5: '额外行李',
  titel6: '一人多座预售',
  paySuccess: '支付成功',
  changeNo: '变更单号:',
  titelTip:
    '温馨提示:系统正在处理您的变更申请,具体进度可点击查看订单详情;如有其它疑问,欢迎致电联系95539 !',
  goback: '返回可退改',
  details1: '查看订单详情',
  PleaseEnter: '请输入',
  cardholder: '持卡人',
  carddetails: '名下的银行卡信息（仅限银联）',
  placeChoose: '请选择(退款将退至该卡持卡人账户)',
  placeChoose123: '请选择',
  placeHoder: '请输入16-19位银行卡号',
  certification: '认证',
  failure: '退款账户认证失败',
  failureCardNo: '您提供的银行卡信息有误',
  checkAgin: '请详细核对',
  Understood: '知道了',
  successCer: '退款账户认证成功',
  cardNum: '卡号',
  cardNum2: '卡号',
  adult: '成人',
  child: '儿童',
  body: '婴儿',
  army: '军残',
  police: '警残',
  mileage: '里程',
  mileageJ: '积分',
  ticketFee: '票价',
  mileageValue: '抵扣金额',
  refundInsurance: '可退保险费',
  airportTaxFee: '机场税',
  fuelFee: '燃油费差',
  fuelFee123: '燃油费',
  otherFee: '其他税费',
  HandlingFee: '手续费',
  costTotal: '票价差额',
  airportTaxFeedif: '机场税差',
  missfee: '误机费',
  extensionfee: '延期费',
  qtPrice: '其它税差',
  difference: '税差',
  changeCost: '变更费用',
  refundCost: '应退金额',
  mileageF: '应退里程',
  pendingReview: '待审核',
  Issued: '已开具',
  Reserved: '已预约',
  unreserved: '未预约',
  ProcessingFailed: '处理失败',
  InvoiceTitle: '发票抬头:',
  TaxpayerIdentNum: '纳税人识别号:',
  phonenum: '收票人手机号:',
  email: '收票人邮箱:',
  Sunday: '(周日)',
  Monday: '(周一)',
  Tuesday: '(周二)',
  Wednesday: '(周三)',
  Thursday: '(周四)',
  Friday: '(周五)',
  Saturday: '(周六)',
  dateWorm: '(日期不对)',
  Sunday1: '周日',
  Monday1: '周一',
  Tuesday1: '周二',
  Wednesday1: '周三',
  Thursday1: '周四',
  Friday1: '周五',
  Saturday1: '周六',
  dateWorm1: '日期不对',
  one: '一',
  two: '二',
  three: '三',
  four: '四',
  five: '五',
  six: '六',
  seven: '七',
  the: '第',
  voyageleg: '航程',
  cabin: '舱',
  share: '共享',
  highspeed: '高铁 ',
  bullet_train: '动车 ',
  Intercity_railway: '城际铁路 ',
  afterChange: '变更后',
  oldTitle: '原航班',
  ni: '身份证',
  ni2: '身份证',
  pp: '护照号：',
  othersId: '其他证件：',
  booklet: '户口簿：',
  certificate: '出生证明：',
  Officer_Cert: '军官证：',
  Police_Cert: '警官证：',
  Taiwan_Cert: '台胞证：',
  home_Cert: '回乡证：',
  Taiwan_permit: '台湾居民居住证：',
  hk_mac: '港澳居民居住证：',
  Passport: '护照：',
  others: '其它：',
  ForeignersId: '外国人永久居留证：',
  Seafarer_Cert: '海员证：',
  Exit_Permit: '外国人出入境证：',
  others2: '其它证件：',
  Passport2: '护照',
  e_passport: '电子护照',
  household_register: '户口簿',
  mp_Cert: '军人及武警证件',
  passId: '通行证',
  others3: '其它证件',
  ForeignersID: '外国人永久居留证',
  seaman_book: '海员证',
  china_issued: '外交部签发的驻华外交人员证',
  Officer_ID: '军官证',
  hkmtId: '港澳台居民居住证',
  others4: '其他证件',
  hkmaId: '港澳通行证',
  twId: '大陆居民来往台湾通行证',
  Sergeant_Cert: '士官证',
  certificate2: '出生医学证明',
  student_ID: '学生证',
  noNewTicketNo: '(当前无新票号)',
  NewTicketNum: '新票号',
  ticketNum: '票    号：',
  PassengerInfo: '乘机人信息',
  TermsOfUse: '使用条件',
  tipcoup1:
    '因您的变更手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  tipcoup2:
    '因您的退票手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  Contact: '联系人',
  Contact123: '请输入联系人',
  name2: '姓名：',
  name2123: '证件号：',
  Contact_phone: '联系手机：',
  bank_card: '银行卡',
  addNewCard: '添加新卡',
  Seat_number: '座位号',
  operation: '操作',
  ChangeSeats: '改选座位',
  SeatsTip1: '正在为您预留机上座位...',
  SeatsTip2: '预留座位失败！',
  SeatsC: '选座',
  SeatsTip3: '系统已为您分配如下座位：',
  SeatsTip4: '预留座位成功！',
  refundTip1: '自身原因无法成行，同意扣除退票手续费',
  refundTip2: '航空公司原因无法成行，申请全额退票',
  tipP1: '由于业务繁忙，请您先提交进入审核阶段',
  tipP2: '审核通过后，变更费用将在订单详情中进行显示',
  tipP3: '您好，外币客票暂不支持小程序端/H5/APP处理，请前往官网办理，谢谢。',
  tipP4: (a, b) => {
    return `本次变更需扣减${a}${b}公里，如交易失败系统将全额退还${a}`;
  },
  tipP5: '您好，该客票非当前渠道购买，请返回原出票渠道进行相关操作。',
  changeNo2: '变更单号：',
  cancelNo: '取消行程单号：',
  refundNo: '退款单号：',
  changeFee: '变更费用：',
  refundFee: '应退金额：',
  refundFeeT: '机票应退金额：',
  loading1: '正在加载...',
  newChangeNo: '新变更单号：',
  doorFee: '专车应退金额',
  tipT1: '注：高铁产品默认原路径退款',
  titelE1: '电子发票开具',
  titelE2: '附加产品',
  titelE3: '查看退款详情',
  titelE4: '*注：如退款失败，可进入详情页，重新发起退款',
  Zhang: '张',
  flie1: '附件上传成功',
  flie2: '提交成功!',
  flie3: '上传附件失败，请重新上传。',
  flie4: '下拉刷新',
  flie5: '刷新中',
  flie6: '加载成功',
  flie7:
    '您的客票非南航官方渠道购买，应退票款已原流水退回至购票账户，具体到账金额以原购票渠道退款为准，详情请咨询原出票渠道。',
  flie8: '绿色飞行-按需用餐',
  choosed: '已选',
  unit: '份',
  gift: '赠送',
  Einvoice: '电子发票',
  resubmit: '重新提交',
  Cancel: '取消',
  pay: '支付',
  complete: '返回',
  modify: '修改退票原因',
  modifyRefun: '退票原因',
  chooseRefun: '请选择退票原因',
  submit: '提交',
  sumitKnow: '我已知晓',
  moreThink: '我再想想',
  UnderReview: '审核中',
  notApproved: '审核未通过',
  Canceled: '已取消',
  Canceled123: '可取消',
  progress1: '您的变更申请已取消，如有疑问，',
  progress2: '请联系在线客服咨询或原出票地办理',
  progress3: '待支付',
  progress4: '支付中',
  progress5: '支付失败',
  progress6: '自动处理中',
  progress7: '变更失败',
  progress8: '非常抱歉，您的变更申请处理失败，请联系南航',
  progress9: '客服95539处理。',
  progress0: '变更成功',
  progress10: '人工处理',
  progress11: '重新提单',
  progressTip1: '放弃变更',
  progressTip2: '已经电话通知',
  progressTip3: '等待处理',
  progressTip4: '变更处理中',
  progressTip5: '处理失败',
  progressTip6: '变更失败 非常抱歉，您的变更申请处理失败',
  progressTip7: '审核未通过',
  progressTip8: '退款处理中',
  progressTip9: '退款成功',
  progressTip0: '退款异常',
  progressTip10: '等待处理',
  progressT1: '退票处理中',
  progressT2: '退款成功',
  progressT3: '已关闭',
  progressT4: '您的退票申请已关闭，如有疑问，',
  progressT5: '请联系南航客服95539。',
  progressT6: '取消行程失败',
  progressT7: '请联系在线客服咨询办理。',
  progressT8: '取消行程成功',
  progressT9: '处理中',
  progressT91: '可退改',
  progressT92: '已退改',
  progressT0: '您的退票申请已取消，如有疑问，',
  progressT10: '变更审核',
  progressT11: '变更处理',
  progressTips1: '处理完成',
  progressTips2: '请联系在线客服咨询或原出票地办理',
  progressTips3: '待支付  请尽快支付',
  progressTips4: '请在支付时限前完成支付',
  progressTips5: '支付失败  请重新支付',
  progressTips6: '支付失败，请在支付时限前完成支付',
  progressTips7: '预计需要2分钟完成处理，请耐心等待。',
  progressTips8: '待处理',
  progressTips9: '请耐心等待',
  progressTips0: '待电话确认',
  progressTips10: '南航客服稍后电话给联系人，请保持手机畅通',
  progressTips11:
    '联系人未接电话或回复不需变更，如有疑问，请联系在线客服咨询。',
  progressTips12:
    '客服已经电话通知到联系人，联系人回复需再确认。后续如需处理，请联系在线客服咨询办理。',
  progresswTip1: '退款审核',
  progresswTip2: '银行受理',
  progresswTip3: '退款受理',
  progresswTip4: '银行卡到账',
  progresswTip5: '代金券到账',
  progresswTip6: '退票处理',
  progresswTip7:
    '审核未通过，如对审核结果有异议，请按要求更新附件重新提交审核。',
  progresswTip8: '请联系原出票渠道处理。',
  progresswTip9: a => {
    return `预计${a}前退款至银行`;
  },
  progresswTip10: '银行受理成功后预计3个工作日到账。',
  progresswTip11: '若逾期未查询到退款到账，请致电银行客服。',
  progresskl1: '若未查询到代金券到账，请联系南航客服95539。',
  progresskl2:
    "退款时卡号验证不通过，请点击下方的 <span style='color: rgba(0, 138, 203, 1)' >[添加新卡]</span>",
  progresskl3: '预计1-5个工作日完成审核，请耐心等待。',
  progresskl4: '查看进度',
  progresskl5: '里程退分异常，请联系在线客服或原出票渠道处理。',
  progresskl544: '里程退款失败',
  refundMoth: '退款方式',
  inpIdCard: '请输入银行卡信息(仅限银联)',
  choosePerson: '请选择持卡人',
  inpMessage: '请输入持卡人身份证姓名',
  inpMessage2: '请输入持卡人身份证号',
  inpIdCard2: '请输入银行卡号',
  cardtip:
    '持卡人必须与乘机人证件号、姓名保持一致方可办理。如身份证姓名中含有特殊字符，如“.”等，请照实输入，否则无法通过实名认证。',
  refundMoth1: '省',
  refundMoth2: '请输入银行卡开户所在省',
  refundMoth3: '请输入准确的开户行所在省份，如：广东省',
  refundMoth4: '城市',
  refundMoth4567: '开户地址',
  refundMoth5: '请输入银行卡开户所在市',
  refundMoth6: '请输入准确的开户行所在市区，如：广州市',
  refundMoth7: '请输入银行卡开户地址',
  refundMoth8: '请输入准确的开户行地址，以免影响退款，如：广州市XXXX支行',
  refundMoth9: '银行预留手机',
  refundMoth0: '请输入银行预留手机',
  refundMoth11: '输入验证码',
  checkCode: '获取验证码',
  refundMoth12: '我已知晓',
  refundMoth13:
    '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
  refundMoth14: '请输入手机号',
  refundMoth15: '人脸识别提示',
  refundMoth16:
    '您好，为保障您的资金安全，极速退款需进行人脸识别，验证持卡人身份，请确认是否继续。',
  refundMoth17: '去认证',
  refundMoth1765: '信息校验失败',
  refundMoth18:
    '您好，为防范金融风险，极速退款需进行人脸识别，请更新最新版APP进行操作，谢谢',
  refundMoth19:
    '您好，为保障您的资金安全，极速退款需进行人脸识别验证，请前往南航官方APP或微信小程序进行退票操作，谢谢。',
  refundMoth20: '退款账户认证失败，您提供的银行卡信息有误，请详细核对！',
  refundMoth21:
    '系统正在处理您的退票请求，请稍等！\n 如提交失败，请稍后尝试重新提交。',
  refundMoth22:
    '您好，您的客票暂无法自助办理，退改申请将流转至原出票渠道进行处理，请确认是否提交。',
  refundMoth23: '3、机票款将以代金券形式退至您的南航账户。',
  refundMoth24:
    '3.机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励及额外里程奖励。',
  refundMoth25: a => {
    return `3、机票款将以代金券形式退至您的南航账户，并额外获得一定额度${a}奖励。`;
  },
  refundMoth26:
    '3、机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励。',
  refundMoth27:
    '您好！如您退票，您的南航北京大兴无限次套票奖励机票权益将失效作废。',
  refundMoth28: '取消退票',
  refundMoth29: '您好！高铁产品暂无法退订。如有疑问，请联系南航客服95539。',
  refundMoth30: '继续退票',
  refundMoth31: '退款后，竞拍调整费用（如有）将自动退款。',
  refundMoth32: '继续退票',
  refundMoth33:
    '尊敬的旅客，如您有同行人，请在退票申请页选择乘机人处勾选，并一同提交身份证明材料。',
  refundMoth34: a => {
    return `您好，客票有效期截止至${a}，请在客票有效期内提交变更或退票申请，谢谢。`;
  },
  refundMoth35: '继续提交',
  refundMoth36: '请选择退款方式',
  refundMoth37:
    '您的客票非南航官方渠道购买，应退票款将原流水退回至购票账户，具体到账金额以原购票渠道退款为准，提交退票后退款信息详情请咨询原出票渠道。',
  refundMoth38: '您尚未开通南航账户，暂无法选择该种退款方式，是否现在开通？',
  refundMoth39: '以后再说',
  refundMoth40: '现在开通',
  refundMoth41:
    '退款至南航账户，仅支持退款至乘机人本人南航账户，请确认是否本人操作？',
  refundMoth42: '其它退款方式',
  refundMoth43:
    "<span style='color: #03bffd;'>代金券：</span><span>南航账户<strong>代金券</strong>可在南航官方渠道为本人或他人购买机票、选座、行李额、贵宾休息室等产品时全额抵扣，也可以拆分多次使用，有效期自退票之日起2年有效，<strong>不可提现</strong>。</span><br/>",
  refundMoth44: (a, b, c) => {
    return `<span style="color:#0096d5;">机票优惠券：</span><span>机票优惠券可在南航官方渠道购买机票时部分抵扣，不可拆分多次使用，仅限（会员号：${a}）本人使用，<strong>不可提现，不退不补</strong>。${!b && c ? ' 具体使用说明如下：' : ''
      }</span><br/>`;
  },
  refundMoth45: a => {
    return `<span style="color:#0096d5;">使用日期：</span><span>${a}</span><br/>`;
  },
  refundMoth46: a => {
    return `<span style="color:#0096d5;">适用业务：</span><span>${a}</span><br/>`;
  },
  refundMoth47: a => {
    return `<span style="color:#0096d5;">价格限制：</span><span>单次产品/服务不低于${a}元（含）可以使用</span><br/>`;
  },
  refundMoth48: '航班日期：',
  refundMoth49: '订单内所有航班的出发日期必须在以下日期范围内：',
  refundMoth50: '无限制',
  refundMoth51: '航班除外日期：',
  refundMoth52: '优惠券不能用于以下日期的航班：',
  refundMoth53: '南航账户',
  refundMoth54: (a, b) => {
    return `<span style="color:#0096d5;">可用的航线：</span><span style="word-wrap: break-word;">${a}</span><br/>
        <span style="color:#0096d5;word-wrap: break-word;">航班号：</span><span style="word-wrap: break-word;">${b}</span><br/>`;
  },
  refundMoth55: (a, b) => {
    return `<span style="color:#0096d5;">适用舱位：</span><span>${a}</span><br/>
              <span style="color:#0096d5;">可用的支付方式： </span><span>仅限${b}</span><br/>
              <span style="color:#0096d5;">备注：</span><span>部分特殊产品不能使用优惠券</span><br/>`;
  },
  refundMoth56:
    '应退机票款将以<strong>代金券</strong>形式退至您的南航账户，并获得一定奖励。',
  refundMoth57: (a, b, c, d) => {
    return `${a}元机票款将以<strong>代金券</strong>
                    形式退至您的南航账户，并可获得${b}额外
                    ${c === 'Y' ? '积分' : '里程'}及
                    ${d}元机票优惠券奖励。`;
  },
  refundMoth58: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户。',
  refundMoth59: (a, b, c) => {
    return `${a}元机票款将以<strong>代金券</strong>形式退至您的南航账户，并可获得${b}额外${c === 'Y' ? '积分' : '里程'
      }奖励。`;
  },
  refundMoth60: (a, b) => {
    return `${a}元机票款将以<strong>代金券</strong>
                    形式退至您的南航账户，并获得${b}
                    元机票优惠券。`;
  },
  refundMoth61: '附件上传失败',
  refundMoth62: '注：附加产品默认从原路径退款',
  refundMoth63:
    '该票来自关爱通渠道，部分金额将会退回关爱通账户额度，退款金额以实际到账为准。',
  refundMoth64: '已选择退款的附加产品',
  refundMoth65: '取消行程',
  refundMoth66: '退票',
  refundMoth67: '请补充银行卡号',
  refundMoth68: '请补充持卡人',
  refundMoth69:
    '为保证资金安全，根据相关法律法规，退票款仅限退回原支付卡，退款仅限一次，如涉及多渠道重复退款等套利行为，南航与出票单位将追究相关责任。',
  refundMoth71:
    '为保证资金安全，根据相关法律法规，退票款仅限退回乘机人本人，退款仅限一次，如涉及多渠道重复退款等套利行为，南航与出票单位将追究相关责任。',
  refundMoth72: '已阅读并同意',
  refundMoth73: '《隐私通知》',
  refundMoth74: '《旅客、行李运输总条件》',
  refundMoth75: '《国际运输总条件》',
  refundMoth76: '原路径退款',
  refundMoth77: '预计3个工作日内到账',
  refundMoth78: '退款到银行卡',
  refundMoth79: '实时到账',
  refundMoth80: '退款至南航账户',
  refundMoth81: '实时到账',
  refundMoth82: '额外里程及优惠券奖励',
  refundMoth83: '额外里程奖励',
  refCupon1: '航段选择',
  refCupon2: '不限制',
  refCupon3: '极速退款',
  refCupon4: '原渠道退款',
  refCupon5: (a, b) => {
    return `享受单次产品/服务免费，最高可抵${a}${b}`;
  },
  refCupon6: (a, b, c) => {
    return `享受单次产品/服务${Number(a) / 10}折，最高可抵${b}${c}`;
  },
  refCupon7: (a, b, c) => {
    return `单次产品/服务满${a}${b / (Number(c) / 100)}（含）可使用`;
  },
  refCupon8: '仅会员本人',
  refCupon9: '额外优惠券奖励',
  refCupon0: '仅会员本人及其受让人',
  refCupon11: '退票费券',
  refCupon12: '多品类券',
  refCupon13: '不满足航线限制',
  refCupon14: '不可与已选优惠券叠加使用',
  refCupon15: '机票',
  refCupon16: '选座',
  refCupon17: '行李',
  refCupon18: '餐食',
  refCupon19: '休息室',
  refCuponDoor: '接送机专车',
  refCupon20: '中转住宿',
  refCupon21: 'PLUS会员',
  refCupon22: '免费变更',
  refCupon23: '候补升舱',
  refCupon24: '登机口升舱',
  refCupon25: '一人多座',
  refCupon26: '现场逾重行李',
  refCupon27: '套票',
  refCupon28: '机场贵宾服务',
  refCupon29: '现场升舱',
  refCupon30: '机票兑换K位',
  refCupon31: '优惠券不适用于该航段',
  refCupon32: '仅限实名认证会员使用',
  refCupon33: '确认',
  refCupon3354: '返回',
  refCupon34: '不可用原因',
  refCupon35: '使用期限：',
  refCupon36: '折',
  refCupon37: '次',
  refCupon38: '使用说明',
  refCupon39: '优惠券号',
  refCupon40: '最高抵用',
  refCupon41: '价格限制',
  refCupon42: '适用业务',
  refCupon43: '航班时刻',
  refCupon44: '订单所选退票航段的航班时刻需在以下范围内：',
  refCupon45: '不限',
  refCupon46: '订单内所有航班的出发日期必须在以下日期范围内：',
  refCupon47: '不限实名认证会员',
  refCupon48: '限制实名认证会员使用',
  refCupon49: '适用航线',
  refCupon50: '可使用的退款方式',
  refCupon51: '退票时限',
  refCupon52: a => {
    return `仅限原航班起飞前${a}小时使用`;
  },
  refCupon53: a => {
    return `仅限原航班起飞后${a}小时使用`;
  },
  refCupon54: a => {
    return `仅限${a}舱位客票使用`;
  },
  refCupon55: a => {
    return `仅限付款渠道为${a}的客票使用`;
  },
  refCupon56: a => {
    return `仅${a}渠道使用`;
  },
  refCupon57: '舱位限制',
  refCupon58: '支付方式',
  refCupon59: '使用渠道',
  refCupon60: '退票场景',
  selectDate1: '继续',
  selectDate2: '重新选择',
  selectDate22: '升舱',
  selectDate3: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  selectDate33: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期符合非自愿变更日期范围，将按非自愿变更处理。点击【继续】，本次将按非自愿变更处理，如需升舱请点击【升舱】（存在升舱费用）`;
  },
  selectDate4:
    '温馨提示：因儿童或婴儿旅客不支持购买“加赠”产品，如继续办理将为所有乘客选择普通客票产品；如需将携带儿童或婴儿的旅客客票变更为“加赠”产品，请联系南航客服95539办理。',
  selectDate5: '出发日期',
  selectDate51212: '您已选择',
  selectDate5121: '（组合）',
  selectDate512: '为您推荐',
  selectDate6: '日',
  selectDate7: '一',
  selectDate8: '二',
  selectDate9: '三',
  selectDate0: '四',
  selectDate11: '五',
  selectDate12: '六',
  selectDate13: '年',
  selectDate14: '月',
  selectDate15: '今天',
  selectDate16: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  ticketChanges1: '周',
  ticketChanges2: '全部日期',
  ticketChanges3: '退改说明',
  ticketChanges4: '伤残人民警察',
  ticketChanges5: '残疾军人',
  ticketChanges6: a => {
    return `以下为${a}退改说明标注,仅供参考,请以实际情况为准`;
  },
  ticketChanges7: '免费托运行李额',
  ticketChanges8: '新航班退改规则',
  ticketChanges9: '变更费',
  ticketChanges9123: '变更费说明',
  ticketChanges0: '变更费/次',
  ticketChanges022: '说明',
  ticketChanges11: '变更时间',
  ticketChanges12: '起飞前24小时之前',
  ticketChanges13: '起飞前24小时之后',
  ticketChanges14: '变更详细说明',
  ticketChanges15: '退票费说明',
  ticketChanges16: '退票时间',
  ticketChanges17: '原客票兑换里程的',
  ticketChanges18: '原客票兑换里程的50%',
  ticketChanges19: '退票详细说明',
  ticketChanges20: '补充说明',
  ticketChanges21: `<span>客票变更后退票，所收的变更手续费不退，客票订座舱位更改后如又发生退票，票价差部分按变更后新票价订座舱位手续费标准办理，原票价按变更前订座舱位退票手续费标准办理，合计收取退票费，且原票变更手续费不退。</span>`,
  ticketChanges22: `<span>客票变更后退票，所收的变更手续费不退，客票订座舱位更改后如又发生退票，票价差部分按变更后新票价订座舱位手续费标准办理，其他按变更前订座舱位退票手续费标准办理，合理收取退票费。</span><span>改期费与升舱费同时发生时,则需同时收取改期费和升舱差额。</span>`,
  ticketChanges23: '客票变更后退票，所收的变更手续费不退',
  ticketChanges24: '售罄',
  ticketChanges25: '余票不足',
  ticketChanges2589: '余位不足',
  ticketChanges2512: '余票',
  ticketChanges26: '经济舱',
  ticketChanges27: '明珠经济舱',
  ticketChanges28: '公务舱',
  ticketChanges281: '头等舱',
  ticketChanges29: '全价',
  ticketChanges2943: '座位靠前 间距更宽',
  ticketChanges294333: '退改条件及行李额',
  ticketChanges2935: '享南航贵宾室 优先机场服务',
  ticketChanges30: '升舱变更费优惠',
  ticketChanges31: '额外获得',
  ticketChanges32: '免费行李',
  ticketChanges33: '已选航班',
  ticketChanges34: '第',
  ticketChanges35: '程',
  ticketChanges35j: '起',
  ticketChanges35jf: '段',
  ticketChanges36: '手续费 + 票价差',
  ticketChanges37: '票价差',
  ticketChanges38: '中转：',
  ticketChanges39: '停留约',
  ticketChanges40: '有餐食',
  ticketChanges41: '无餐食',
  ticketChanges42: '经停：',
  ticketChanges42a: '次日达',
  ticketChanges43: a => {
    return `该航班为
            ${a}
            承运的南航代码共享航班，登机前请到
            ${a}
            值机柜台办理值机。`;
  },
  ticketChanges46: '实际承运',
  ticketChanges47: '收起',
  ticketChanges48: '展开',
  ticketChanges49: '航班详情',
  ticketChanges50: a => {
    return `您好！新航班距离上一航班不足${a /
      60000}分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges5aa: a => {
    return `您好！新航班距离下一航班不足${a /
      60000}分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges51: (a, b, c) => {
    return `您好！新航班与上一航班衔接时间不足${a === true ? b : c
      }分钟，请选择其它航班。`;
  },
  ticketChanges53: (a, b, c) => {
    return `您好！新航班距离下一航班不足${a === 0 ? b : c
      }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges54: (a, b, c) => {
    return `您好！新航班距离下一航班不足${a === true ? b : c
      }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges55: (a, b, c) => {
    return `您好！新航班距离下一航班不足${a === 0 ? b : c
      }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges56: (a, b, c) => {
    return `您好！新航班距离下一航班不足${a === true ? b : c
      }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges57: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  ticketChanges58: (a, b) => {
    return `起飞前${a}小时至${b}小时之内`;
  },
  ticketChanges59: (a, b) => {
    return `起飞后${a}小时至${b}小时之内`;
  },
  ticketChanges60: (a, b) => {
    return `起飞前${a}小时至起飞后${b}小时之内`;
  },
  ticketChanges61: a => {
    return `起飞前${a}小时之后`;
  },
  ticketChanges62: a => {
    return `起飞后${a}小时之外`;
  },
  ticketChanges63: a => {
    return `起飞前${a}小时之前`;
  },
  ticketChanges64: a => {
    return `起飞后${a}小时之内`;
  },
  ticketChanges65: '不支持在线变更60分钟内起飞的航班。',
  ticketChanges66:
    '本次航班临近起飞时间，请先联系在线客服咨询，或与值机柜台确认仍可值机后再预订，因误机产生的费用须自行承担。',
  ticketChanges67: '同意并继续',
  ticketChanges68:
    '您好,如您变更至首都机场航班,您的南航北京大兴无限次套票奖励机票权益将失效作废',
  ticketChanges69:
    '您好,如您变更至代码共享航班,您的南航北京大兴无限次套票奖励机票权益将失效作废',
  ticketChanges70: '取消变更',
  ticketChanges71: '继续变更',
  ticketChanges71a: (a, b) => {
    return `注：始发机场将变更为${a}，到达机场将变更为${b}，请务必确认`;
  },
  ticketChanges71s: a => {
    return `注：始发机场将变更为${a}，请务必确认`;
  },
  ticketChanges71d: a => {
    return `注：到达机场将变更为${a}，请务必确认`;
  },
  ticketChanges72: '部分航班始发地改为',
  ticketChanges73: '部分航班目的地改为',
  ticketChanges74: '，请注意区分。',
  ticketChanges75: '更换行程',
  updateDetail0: '单号：',
  updateDetail1: '变更单：',
  updateDetail2: '退票单：',
  updateDetail3: '票号: ',
  updateDetail4: '票价(不含税费)',
  updateDetail5: '总价 : ',
  updateDetail6: '总变更费 : ',
  updateDetail7: '应退金额 : ',
  updateDetail8: '取消行程成功',
  updateDetail9: '取消行程失败',
  updateDetail10: '已提交未确认',
  updateDetail11: '已确认待退票',
  updateDetail12: '已退票',
  updateDetail13: '已取消',
  updateDetail14: '已调账',
  updateDetail15: '已退款',
  updateDetail16: '已关闭',
  updateDetail17: '已受理',
  updateDetail18: '处理中',
  updateDetail19: '处理失败',
  updateDetail21: '处理成功',
  updateDetail22: '审核中',
  updateDetail23: '审核不通过',
  updateDetail24: '待支付',
  updateDetail25: '支付失败',
  updateDetail26: '退款处理中',
  updateDetail27: '自动处理中',
  updateDetail28: '变更失败',
  updateDetail29: '退款异常',
  updateDetail30: '待人工处理',
  updateDetail31: '人工处理中',
  updateDetail32: '待电话确认',
  updateDetail33: '重新提交',
  updateDetail34: '放弃变更',
  updateDetail35: '已电话通知',
  updateDetail36: '变更成功',
  updateDetail37: '退款成功',
  updateDetail38: '状态错误',
  updateDetail39:
    '您好，外币客票暂不支持小程序端/H5/APP处理，请前往官网办理，谢谢。',
  updateDetail40: (a, b) => {
    return `本次变更需扣减${a}${b}公里，如交易失败系统将全额退还${a}。`;
  },
  updateDetail4122: '备注',
  updateDetail41:
    '自愿变更可能收取一定的手续费及票价价差；航班延误或取消，符合规定的允许免费改期一次。',
  updateDetail42:
    '当客票包含多个使用规则时，将按照发生变更的航程中最严格的使用规则执行。变更费按各变更航段最高收费标准收取，按次计费。',
  updateDetail43: '客票变更需在客票有效期内进行。',
  updateDetail44: '若变更费为待审核，具体变更费用以审核后短信中的金额为准。',
  updateDetail45:
    '自愿退票可能会收取一定手续费；航班延误或取消，符合规定的可以免手续办理所有未使用航段的退票。',
  updateDetail46:
    '当客票包含多个使用规则时，将按照全航程最严格的使用规则执行。并且如客票已部分使用，退票时，需扣除已使用航段上相应的适用票价及已使用税款，收取退票手续费和误机费（如有）。',
  updateDetail47:
    '若退票费为待审核，具体退票费用以审核后短信中的金额为准，提交退票后不得取消。',
  updateDetail48: '所有未使用的可退航段需一起申请退票。',
  updateDetail49:
    '2-11岁儿童及2岁以下占座婴儿，变更/退票时收取与成人相同的费用；2岁以下不占座婴儿，变更/退票时不收取费用。',
  updateDetail50:
    '以上规定仅供参考，其余未说明事项请以南航实际规定为准，如有疑问，请联系95539。',
  updateDetail51: '行程已取消',
  updateDetail52: '客票号',
  updateDetail53: '退改费用及更多退改规则，',
  updateDetail54: '请查询“退改说明”',
  updateDetail55: '证件号',
  updateDetail56: '变更',
  updateDetail57: '退票',
  updateDetail5723: '手续费：',
  updateDetail58: '去支付',
  updateDetail59: '可输入票号/证件号/姓名进行搜索',
  updateDetail60: '票号或证件号或姓名有误',
  updateDetail61: '重新登录',
  updateDetail62: '当前您没有可办理退改的机票。',
  updateDetail63: '已处理',
  updateDetail64: '抱歉！暂无法找到您可退改的客票。建议您先完成',
  updateDetail65: '您现在暂无可退改订单/客票',
  updateDetail66: '暂无符合您搜索的机票',
  updateDetail67: '暂未查询到符合要求的客票/订单',
  updateDetail68: '点击',
  updateDetail69: '查询更多客票',
  updateDetail70: '航班时间',
  updateDetail71: '旅客类型',
  updateDetail72: '该功能已关闭，暂不支持访问',
  updateDetail73: '请输入错购客票信息',
  updateDetail74: '请输入新购客票信息',
  updateDetail75: '请选择客票错购场景',
  updateDetail76: '请输入客票号！',
  updateDetail77: '请输入正确的客票号！',
  updateDetail78: '点击选票或输入票号',
  updateDetail79: '出发',
  updateDetail80: '暂无搜索结果',
  updateDetail81: '正在查询...',
  updateDetail82: '错购客票',
  updateDetail83: '点击选票或输入新票号',
  updateDetail84: '新购客票',
  updateDetail85: '错购场景',
  updateDetail86: '提交申请',
  updateDetail87: '机票退改',
  updateDetail88: '变更进度',
  updateDetail89: '取消行程进度',
  updateDetail90: '退票进度',

  gender: '性别',
  nationality: '国籍',
  tipError: (a, b) => {
    return `旅客${a}的${b}格式错误`;
  },
  certiIssuing: '证件签发地',
  supplement: a => {
    return `请补充旅客${a}的信息`;
  },
  suppleMessage: (a, b) => {
    return `请补充旅客${a}的${b}`;
  },
  passenger: '旅客',
  save: '保存',
  SuppPsginfo: '补充旅客信息',
  male: '男',
  female: '女',
  selectDetailInfo: '请选择详细信息',
  prePsgMessage: '请确认所填姓名和乘机证件一致',
  mandatory: '必选',
  dateBirth: '出生日期',
  country: '国家/地区',
  documentType: '证件类型',
  Required: '必填',
  validityPeriod: '证件有效期',
  additionalTip: '购买产品数量不可超过成人数量',
  additionalTip2: '该宝贝不能购买更多哦',
  additionalTip3: '选择休息室',
  checked: '已选择',
  checked123: '/人起',
  recommends: '为您推荐一下服务',
  orderTotal: '订单总额',
  details: '明细',
  addPsgTip: '您好,本次变更需补充旅客信息',
  replenish: '去补充',
  replenish123: '请输入公务员信息。',
  verifyTip: '校验失败，请稍后重试或联系在线客服咨询。',
  verifyTip2: '输入的公务员姓名与变更乘机人不符，请重新输入。',
  verifyTip3: '输入的银行卡bin号位数不符，请重新输入。',
  verifyTip4: '本次变更需扣减里程公里，如交易失败系统将全额退还里程',
  verifyTip5: '自愿变更后，竞拍调整费用（如有）将自动退款。',
  verifyTip6:
    '非自愿变更后，竞拍调整费用（如有）是否可退将与变更后新客票状态关联。',
  chooseFood: '请选择是否机上用餐',
  yes: '是',
  no: '否',
  good: '好的',
  no123: '奖励',
  foodSelect: a => {
    return `勾选“否”，取消机上用餐，获取${a}奖励`;
  },
  greenFlight: '绿色飞行',
  benefits: '权益福利',
  civilMsg: '请输入公务员信息',
  foodPsg: '请选择机上用餐的旅客',
  greenPsg: '请选择绿色飞行的旅客',
  selectAll: '全选',
  submitChange: '提交变更',
  inputPsgName: '请输入联系人姓名',
  telephone: '联系手机',
  telephone123: '请输入联系手机',
  VerificationCode: '验证码',
  rcRuleTip5: '可能产生相应退票手续费',
  rcRuleTip6:
    '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为自愿退票，按照',
  rcRuleTip1:
    '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  rcRuleTip2:
    '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为非自愿退票，免收退票手续费。',
  rcRuleTip3: '此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  rcRuleTip4: '此次为非自愿退票，免收退票手续费。',
  rfInstruction: '退改签说明',
  unused: '完全未使用',
  partiallyUsed: '部分已使用',
  noChange: '不得变更',
  noRefund: '不得退票',
  referenceTip: '以上说明仅供参考，请以实际情况说明。',
  officialCard:
    '是指公务卡卡号的前6位；<br/>例如：工行的公务员卡Bin号是628288；',
  bankCardNo: '银行卡Bin号',
  inpuitCardholder: '请输入持卡人',
  reCode2: '推荐码（选填）',
  inputRecode: '请输入员工推荐码',
  reCode1: '推荐码',
  segPsg: '/航段/人',
  people: '/人',
  people123: '人',
  fillInfo: '填写信息',
  gotoRc: '前往退改',
  queryTip3: '当前您没有已取消行程的订单',
  queryTip4: '当前您没有可办理取消行程的机票。',
  queryTip5: '未找到相关客票/订单信息',
  ticketN: '票号：',
  ticketN123: '乘机人',
  ticketNow: '当前',
  totalPrice: '总价：',
  totalChangeFee: '总变更费：',
  muTip: '该客票暂不支持自助取消行程，请联系东航客服95530处理。',
  caTip: '该客票暂不支持自助取消行程，请联系国航客服95583处理。',
  huTip: '该客票暂不支持自助取消行程，请联系海航客服95339处理。',
  psgTicNo: '客票号：',
  cancellationTip: '取消行程费用及更多规则，请查询“取消行程说明”',
  cancellationInt: '取消行程说明',
  reCertification: '重新认证',
  faceFail: '对不起，未通过实名认证',
  fail: '失败',
  faceSuccess: '恭喜您，通过实名认证',
  success: '成功',
  weekDay: '一,二,三,四,五,六,日',
  discountRecom: '优惠推荐',
  csair: '中国南方航空',
  changeDes: '变更说明',
  refundDes: '退票说明',
  couponUse: '可用优惠券',
  couponUnUse: '不可用优惠券',
  close: '关闭',
  tikcetPrice: '票面价：',
  refundhfee: '当前退票手续费：',
  changehfee: '当前变更手续费：',
  irefundRule: '客票符合非自愿退改条件，费用计算按非自愿退改规则进行处理',
  calTip1: '按当前时间和自愿退票计算',
  calTip2: '按当前时间和自愿变更计算',
  immeRefund: '马上退票',
  changeSeg: '变更航程',
  cancelTip1:
    '若您的航程后续仍需出行，但出行时间待定，可取消行程，待出行时间确认后，对客票进行变更操作，变更手续费按当前取消行程时间计算。',
  cancelTip2: '取消行程后，将无法再乘坐本航班，且无法恢复。',
  costCal: '费用计算',
  percentage: '百分比展示',
  numerical: '数值展示',
  process: '申请流程',
  viewDe: '查看详情',
  free: '免费',
  onlyTax: '仅退税费',
  front: '前',
  timeNode: '时间节点',
  noTimeLimit: '不限制时间',
  couponTip8: '变更费券',
  couponTip10: '不满足价格限制',
  couponTip12: '与已选优惠券的支付方式不可同时使用',
  pSeat: '国内优选座位',
  speedyBoarding: '快速登机',
  couponInfo1: '因所选择机票变更手续费为0，无需使用优惠券',
  couponInfo5: '仅限会员本人使用',
  couponInfo6: '航班日期不符合条件',
  couponInfo9: '订单所选原航班的航班时刻需在以下范围内：',
  couponInfo11: '最高抵用',
  couponInfo12: '价格限制',
  couponInfo14: '用于变更时，可用于以下变更后舱位',
  couponInfo15: '当日变更',
  couponInfo16: '仅航班当天允许使用',
  couponInfo17: '可用的支付方式',
  couponInfo18: '变更时限',
  couponInfo22: '客票预定后',
  applicationDate: '适用日期',
  to: '至',
  except: '除外',
  outinHours: '小时之外',
  networkFail1: '您的网络好像不给力哦',
  networkFail2: '服务器繁忙，请您稍后再试',
  discounted: '降价客票',
  discountedTip1: '请输入旧客票信息',
  discountedTip2: '请输入新客票信息',
  discountedTip6: '新旧客票号不能相同，请重新输入',
  oldTic: '旧客票',
  newTic: '新客票',
  login: '登录',
  idTikcetNo: '证件号或者票号',
  surnamePsg: '乘机人的姓氏',
  namePsg: '乘机人的名字',
  kindTip1: '1.请使用乘机人的姓名、证件号或者票号进行查询。',
  kindTip2:
    '2.变更适用于南航国内客票，以及航班不正常情况下的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip3:
    '3.退票适用于南航国内客票，以及南航官网、APP、微信小程序、微信公众号、客服渠道购买的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip4: '4.对于以上暂未支持自助退改的客票，请联系南航客服95539办理退改。',
  kindTip5: '请使用乘机人的姓名,证件号或票号如<br />7840000000000进行查询',
  queryRc: '查询退改记录',
  confirmMsg: '请确认您的信息',
  invoice2: '纳税人识别号:',
  invoice3: '公司地址:',
  invoice4: '公司电话:',
  invoice5: '公司开户行:',
  invoice6: '公司账号:',
  invoice7: '收票人手机:',
  invoice9: '退票旅客:',
  invoice10: '请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收',
  invoiceApoint: '提交发票预约信息',
  inputInvoice: '请输入您的电子发票信息',
  invoiceCont: '发票内容: 退票手续费',
  invoiceType: '发票类型:',
  invoiceMsg1: '个人',
  invoiceMsg2: '企业',
  invoiceMsg3: '非企业性单位',
  invoiceMsg4: '选择发票抬头',
  invoiceMsg5: '请输入公司名称',
  invoiceMsg6: '请输入纳税人识别号',
  optional: '选填',
  invoiceMsg7: '请输入联系人邮箱',
  invoiceMsg8: '请输入联系人手机',
  invoiceTip1: '为同行人开具:',
  invoiceTip2:
    '1.请您确认填写信息是否正确，邮箱请填写真实地址，否则将无法收到电子发票邮件！',
  invoiceTip3:
    '2.税总（2017）16号文件规定，2017年7月起，企业必须提供税号才能开票，否则不能作为报销凭据。',
  view: '查看',
  companyName: '公司名称',
  TaxCode: '纳税人识别码',
  companyAddress: '公司地址',
  companyPhone: '公司电话',
  openBank: '公司开户行',
  companyAccount: '公司账号',
  voiceTitle: '我的发票抬头',
  default: '默认',
  taxId: '税号:',
  addPsg: '添加同行人',
  selectDate: '选择新航班日期',
  additional1: '请选择需要取消的附加产品',
  additional2: '提交退票申请后，机票包含的',
  additional3: '将跟随机票一起作废，请谨慎操作。',
  trainTip1: a => {
    return `此为空铁联运订单，旅客${a}使用了火车票优惠券，机票与火车票需一起退订，谢谢`;
  },
  trainTip2: '此为空铁联运订单，机票与火车票需一起退订，谢谢',
  selectResaon: '请选择退票原因！',
  notCancel: '暂不取消',
  notCancel123: '确认取消',
  domestic: '国内',
  international: '国际',
  additional5:
    '您好！退票成功后请留意额度返回情况，如未成功返回，可登录员工旅行专区申请返回额度。',
  firstJn: '第一程',
  firstJn12321: '到',
  asd0: '自愿退票',
  asd1: '个人原因',
  asd2: '非自愿退票',
  asd3: '航班延误',
  asd4: '航班取消',
  asd5: '航班超售',
  asd6: '航班变动',
  asd7: '因病退票',
  asd8: '其它',

  inputTip1: '系统繁忙，请稍后重试！您也可以联系原出票单位办理。',
  inputTip2: '请输入联系人',
  inputTip3: '请输入手机号',
  inputTip4: '联系手机:',
  trainPrice: '高铁票价',
  trainHandFee: '高铁手续费',
  fareCost: '票价',
  fuelTaxTotal: '燃油费差',
  airportTaxTotal: '机场税差',
  premium: '可退保险费',
  airportTax: '机场税',
  fuelCost: '燃油费',
  counterFee: '手续费',
  refundCoupon: '退票优惠券',
  totalTax: '可退税费',
  ticketPrice: '票价',
  deductionMileage: '抵扣里程',
  mileageCharge: '里程手续费',
  discontedFee: '手续费优惠',
  retainUpgrades: '退票挽留升舱',
  mileageTxt: '实际到账里程数请登录会员里程账户查看。',
  actualMileage: '实退里程',
  expiredMileage: '过期里程',
  delayMileage: '延期里程',
  actualExpired: '实际过期里程',
  reSubmitTip1: '提交退票申请后，机票包含的',
  reSubmitTip2: '将跟随机票一起作废，请谨慎操作。',
  reSubmitTip3: '1.以上里程过期信息仅供参考；',
  reSubmitTip4: ' 2.非自愿退票退还的奖励里程将按原有效期顺延 6 个月；',
  reSubmitTip5: ' 3.退还到账里程如已过期则视为失效，请以实际到账为准。',
  reSubmitTip6: '此次为非自愿退票，免收退票手续费。',
  reSubmitTip7: '此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  reSubmitTip8:
    '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为非自愿退票，免收退票手续费。',
  reSubmitTip9:
    '因近期退票业务量大，您的退票申请预计7天内完成退款，手续费将参照客票使用条件计算，具体退还金额请以审核结果为准。',
  reSubmitTip10:
    '因疫情防控需要，请密切关注南航官网发布的特殊退改政策公告。需要办理特殊退改的客票，请联系原购票单位或者南航客服95539办理。',
  caRules: '计算规则',
  couponQuantity: '优惠券数量',
  couponperiod: '优惠券有效期',
  period: '有效期',
  mileageperiod: '里程有效期',
  aa: '张',
  coValue: '优惠券面值',
  mileageLimit: '里程额度',
  limit: '额度',
  coCode: '优惠券券码',
  giveCou: '赠送优惠券',
  giveMileage: '赠送里程',
  feeInfo: '费用信息',
  addSvc: '附加服务',
  guaranteeSvc: '保障服务',
  trainFee: '应退高铁金额',
  expiredInfo: '过期信息',
  expiredInfo123: '费用总计',
  voucher: '代金券',
  refundMileage: '应退里程',
  seletedCoupon: '已选优惠券',
  couponSelectTipR: '可用于抵扣退票手续费',
  couponSelectTipC: '可用于抵扣变更手续费',
  csairAccount: ' 南航账户',
  couponUseTip1:
    '可在南航官方渠道为本人或他人购买机票、选座、行李额、贵宾休息室等产品时全额抵扣，也可以拆分多次使用，有效期自退票之日起2年有效，',
  couponUseTip2: '不可提现。',
  couponUseTip3: (a, b) => {
    return `可在南航官方渠道购买机票时部分抵扣，不可拆分多次使用，仅限
                ${a}（卡号：${b}
                ）本人使用，
                <strong>不可提现，不退不补</strong>
                ，使用规则以实际到账查询结果为准。`;
  },
  actualTrans: '实际承运',
  transportation1: '该航班为',
  transportation2: '承运的南航代码共享航班，登机前请到',
  transportation3: '值机柜台办理值机。',
  transportation4: '按住滑块,拖动完成拼图',
  transportation5: '请登录退改客票的购票人或乘机人帐号进行操作',
  tips: '提示',
  memberShip1: '诚邀非会员:',
  memberShip2: '申请加入南航会员明珠俱乐部,尊享会员权益',
  skip: '跳过',
  memberShip3: '单个文件名不超过150字',
  memberShip4: '填写信息',
  memberShip5:
    '因您的退票手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  memberShip6: '请输入明珠会员密码',
  memberShip7:
    '由于银联系统对于姓名包含特殊符号暂时没有统一标准，认证失败可尝试取消特殊符号选项再试一次。',
  reInput: '重新输入',
  feedback: '我要反馈',
  manualService: '在线人工客服',
  onliveService: '在线客服',
  automatic1: '自动加载中...',
  automatic2: '自动处理中...',
  additional: '附加产品',
  addproducts: '增加产品',
  adjustment: '竞拍调整',
  copy: '1份',
  trainTicket: '火车票',
  excessBaggage: '逾重行李',
  paidSeat: '付费选座',
  interval: '间',
  late: '晚',
  Processing1: '正在为您处理...',
  Processing2:
    '您的变更申请已提交，请稍后在“处理中”或“已退改”列表中查看详情或完成支付。若无法查询到相关变更申请，请重新提交变更，谢谢。',
  Processing3:
    '您的退票申请已提交，稍后请在“处理中”或“已退改”模块查看。若您无法查询到您的退票申请，请重新点击“退票”按钮申请客票退票，谢谢。',
  progress: '进度条',
  veriTip1: '请输入员工推荐码',
  veriTip2: '验证码输入有误，请重新输入',
  veriTip3:
    '请确认您是乘机人本人，或已征得乘机人的许可进行取消值机，若非以上情形，您将有可能被追究法律责任。',
  checkTip1: '注：在您成功操作取消值机后将无法登机。',
  checkTip2: '您确定要取消已办理的值机手续吗？',
  seMethod: '选择“退款至南航账户”',
  rewardTip2: '享受额外权益奖励。',
  rewardTip3: '元机票优惠券',
  modify22: '前往修改',
  giveUp: '放弃',
  sureT: '应退',
  sureTs: '实退',
  deleFile: '是否确认删除文件',
  deleteS: '文件已删除，可重新上传文件',
  uploadF: '上传附件',
  File: '附件',
  zhengm: '请上传相关证明文件',
  as1: '特殊退票申请',
  as2:
    '如因疾病原因，需申请特殊退改，请选择原因后，按指引上传相关证明材料或联系原出票单位办理。',
  as3:
    '尊敬的旅客，如您有同行人，请在退票申请页选择乘机人处勾选，并一同提交身份证明材料。',
  as4: '疫情防控',
  as5: '病退申请',
  as6: '情况说明',
  as7: '请上传文字版情况说明图片',
  as8: '身份证明',
  as9: '继续添加',
  as0: '疫情证明文件',
  as11: '医疗机构就诊缴费发票或住院押金证明',
  as12: '请上传身份证正反面图片',
  as13:
    '请确认您是乘机人本人，或已征得乘机人的许可进行取消值机，若非以上情形，您将有可能被追究法律责任。',
  as14: '注：在您成功操作取消值机后将无法登机。',
  as15: '选择新航班',
  load11: '加载中',
  loginFail: '登录失效',
  timeOut: '网络超时',
  yichang: '网络异常',
  title: '温馨提示',
  title_delay: '航班延误/取消',
  title_explain: '退改说明',
  title_Confirm_error: '提交失败',
  applicationSubmission: '申请提交',
  back: '返回',
  okBtn: '确定',
  cancel: '取消',

  goon: '继续',
  myOrder: '我的订单',
  goonRefund: '继续退票',
  goonChange: '继续变更',
  quitChange: '放弃变更',
  allsubmit: '一起提交',
  ressubmit: '重新提交',
  yes: '是',
  no: '否',
  keepsubmit: '继续提交',
  orderStatusChange: '您好！当前变更单的状态已改变，不可再进行支付',
  cardBin: '银行卡Bin',
  cardBinMsg: '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>',
  updateDetail: {
    title: '温馨提示',
    content:
      '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
    noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
    cancelOrder: '您好！您确定要取消该变更单吗? ',
    cancelOrderOk: '取消变更成功！',
    cancelOrderFailed:
      '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
    costCalculation: '费用计算',
    huChangeTip:
      '本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339',
  },
  endorsedApply: {
    addPsgSuccess: '添加同行人成功',
    OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
    ManyAdult:
      '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
    flightDelayOrCancel:
      "<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style='margin: 0.2rem 0;'>2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>",
    needSelectPsg: {
      content: '您好！添加同行人需先选择乘机人。',
    },
    pleaseSelectChangeFlightAndPsg: '请您先勾选所需变更的航段和乘机人！',
    pleaseSelectRefundFlightAndPsg: '请您先勾选所需退票的航段和乘机人！',
    pleaseSelectChangeFlight: '请您先勾选所需变更的航段！',
    pleaseSelectRefundFlight: '请您先勾选所需退票的航段！',
    pleaseSelectTrainFlight:
      '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
    pleaseSelectPsg: '请您先勾选乘机人！',
    pleaseSelectHtlight:
      '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
    selectedPsgMustHasAdult:
      '您好！暂不支持单独儿童变更。如有疑问，请联系南航客服95539处理。',
    selectedPsgbady:
      '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
    selectedFlightError(text) {
      return `您好！${text}的航班需要勾选后方可进行一下步操作，请确定是否勾选该行段？`;
    },
    selectedFlightSuccess: '选择成功，请再选择下一段航班日期!',
    onlySelectOneAdultInTAOrder:
      '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
    cancelCheckIn: '取消值机',
    selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。',
    hotelChangeTip: '该类型订单中所有可变航段和乘机人需一同变更。',
  },
  selectDateObj: {
    selectedFlightDateBefore:
      '您好！您选日期不能在前一个航班日期之前，请重新选择日期。',
    selectedFlightDateAfter:
      '您好！您选日期不能在后一个航班日期之后，请重新选择日期。',
    selectedFlightDateBeyondWQT:
      '该日期无法享受优惠变更手续费的权益，请确认是否更改日期。',
    selectedFlightDateSeasonTicket:
      '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
    selectedFlightDateExceeds:
      '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
    selectMuFlightDate:
      '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。',
  },
  ticketChanges: {
    optionalFlight:
      '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
    electionFlight:
      '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
    checkpending:
      '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
    changeCabin_1:
      '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
    changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
    compareCabin(text) {
      return `您所选舱位为降舱变更，已兑换${text}不退还。`;
    },
  },
  addPersonMessage: {
    afterSaleChangeConfirm_ok: {
      title: '提交成功',
      content: '',
    },
    afterSaleChangeConfirm_error:
      "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
    afterSaleChangeConfirm_fail: {
      title: '提示',
      content: '',
    },
  },
  applySubmit: {
    inputContactInfo: {
      content: '请输入并保存联系人信息',
    },
    inputRightContactInfo: '您好！请输入正确的手机号',
    verificationCode: '请输入六位验证码！',
    afterSaleChangeReqPayOK_error:
      '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
    afterSaleRefundApp_error:
      '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
    checkTips_fzy:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；<br/>2、此次为非自愿退票，免收退票手续费。</div>",
    bingtui_zy:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>",
    checkTips_zy:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/><span>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；</span><br/>2、此次为自愿退票，按照退改规则可能产生相应退票手续费。</div>",
    checkTips_pengdingzy:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/><span>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；</span><br/>2、此次为自愿退票，按照退改规则可能产生相应退票手续费。<br/><span style='color:#e5004a'>3、实际退票手续费将按客票使用规则进行人工审核，人工审核完成后将直接进行退款处理。</span>因退票手续费可能较高，若您不知晓退票手续费计算规则，建议联系原出票渠道或南航客服咨询后进行提交。</div>",
    yddqTip:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>",
    quotaTip:
      "<span style='color:#e5004a'>额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>",
    contact_important: '请补充联系人信息',
    error_certno: '请输入证件号',
    error_certnoF: '请输入正确的证件号',
    error_name: '请输入持卡人',
    no_verification: '请输入验证码！',
    get_verification: '请获取验证码！',
    error_verification: '您输入的验证码有误，请重新输入。',
    overtime_verification: '您输入的验证码已超时，请重新获取。',
    eleven_phone: '请输入11位国内手机号。 ',
    isCheckedRead: '请阅读并同意服务协议',
    artificial:
      '您好！本次变更需人工审核，客服稍后短信通知您审核结果及变更费用。',
    error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
    no_bankcard: '请输入16-19位银行卡号',
    error_referral: '推荐码格式不正确！',
    changeCabin:
      '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
    happyFlying:
      '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
    repeat: '文件名重复，无法上传，请更名后上传',
    selectedError:
      '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
    muFileError:
      "附件上传格式为'JPG', 'PNG', 'DOC', 'JPEG', 'DOCX'，所有附件大小不能超2M。",
    fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
    fileTip:
      '请根据实际情况，按需上传如下附件：1.情况说明 2.身份证正反面图片或其他身份证明官方材料 3.出行受阻官方证明材料 4.目的地活动延期或取消官方证明材料 5.健康码或核酸检测异常截图6.其他疫情原因导致无法出行的官方证明材料。',
    fileTipIll: '请上传南航认可医疗机构开具的医疗缴费发票或住院押金证明。',
    fileTipProof:
      '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
    noRefundMode:
      '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
    thanksPerson: '谢谢您的支持与配合！',
    contactInfo:
      '温馨提示：请您认真核对航班信息、乘机人姓名及证件信息、联系电话等，以免影响乘机。',
    transferInfo:
      '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准, ',
    pleaseCheckIsFood: '请您先勾选是否机上用餐',
    fileSuppleTip: "您已勾选了病退申请，但未上传身份证明或相关医疗证明材料，请补充材料后提交。"
  },
  feeQuery: {
    selectFlight: '请选择想要退票或变更的航段! ',
    refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
    canotChange: '您选择的航段不可变更，请重新选择',
    modification: '抱歉，您选择的航段不可变更',
  },
  loginFeeQuery: {
    inputTicketNoOrId: '请输入票号或者证件号！',
    inputName: '请输入旅客姓名！',
    inputTicketNo: '请输入航班号！',
    inputFlightDate: '请选择航班日期！',
  },
  refundChangeCompute: {},
  detailsMessage: {
    inputContactPersonName: '联系人信息很重要，请补充完整',
    inputRightContactPersonName: '请输入正确的联系人姓名',
    inputContactPersonPhone: '联系人信息很重要，请补充完整',
    inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入',
  },
  realNameVerify: {
    descTitle: '退款账户认证说明',
    descContent:
      '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
    createRefundTa_error:
      "<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style='display: inline-block;' href='tel:95539 '> <u>95539</u></a>人工服务垂询。</div>",
  },
  ReformProcess: {},
  subInfomation: {
    payOverTime: {
      title: '支付超时',
    },
  },
  ElectronicInvoice: {
    noCompanyName: '请输入公司名称',
    noTaxpayerIdCode: '请输入纳税人识别码',
    noEmail: '请输入收票人邮箱',
    noPhone: '请输入收票人电话',
    erroeEmail: '邮箱输入有误，请重新输入',
    errorTaxpayerIdCode: '纳税人识别号不符合规则',
    errorPhone: '请正确输入收票人电话',
    tip:
      '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！',
  },
  changeMember: {
    checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人',
  },
  rateTip: {
    rateTip: '请选择评分！',
    rateSuccess: '感谢您的反馈！',
  },

  mileageMsg: {
    title(text) {
      return `${text}计算规则`;
    },
    info(text) {
      return `计算公式:<br/>实际过期${text}=过期${text} - 延期${text}<br/>实退${text}=应退${text} - 实际过期${text}`;
    },
    btn: '知道了',
  },
  cancelPage: {
    CancellationTip:
      "<p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem' ><strong style='font-size:0.26rem;color:#009cd9'> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>",
  },
  tchan: '机票变更',
  trefun: '退票申请',
  tchanges: '变更申请',
  cancelt: '取消行程申请',
  tcu: '退改/升舱',
  gongwu: '公务员信息认证',
  payresun: '支付结果',
  yasd: '退款账户认证',
  refundName: '退票详情',
  changeName: '变更详情',
  refundSeat: '取消行程详情',
  serveC: '餐食服务',
  contact: '联系',
  refundSubmitTip1: '系统正在处理您的退票请求，请稍等！',
  refundSubmitTip2: '如提交失败，请稍后尝试重新提交',
  ticInfo: '客票信息',
};



// WEBPACK FOOTER //
// ./src/config/commonlang/cn.js